module.exports = __webpack_public_path__ + "static/media/layout2.d6c0acca.png";